import { SCOPE_TOKENS, RecordScopeTestFunctions, RecordScopeTokensRequest } from './types';

export const scopeTestFns: RecordScopeTestFunctions = {
  [SCOPE_TOKENS.STREAMDECK]: (scope): boolean => scope.match(/streamdeck/i) !== null,
};

export const scopeRequest: RecordScopeTokensRequest = {
  [SCOPE_TOKENS.STREAMDECK]: ['streamdeck:skip-alert', 'streamdeck:pause-resume'],
};
